import { useState, useEffect } from 'react'
import useTranslate from '../../../i18n/useTranslate'
import useLookupService from '../../lookup/useLookupService'

export type OptType = {
    label: string
    value: string
}

const useProjectType = () => {
    const translate = useTranslate()
    const callLookup = useLookupService()
    const [projectT, setProjectT] = useState<OptType[]>([])

    const getProjectType = async () => {
        const res = await callLookup.callProjectTypeLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
            }
        })

        setProjectT(formatedData)
    }

    const initialLoad = () => {
        getProjectType()
    }
    useEffect(() => {
        initialLoad()
    }, [translate.languageStore.currentLanguage])

    return { projectT }
}

export default useProjectType
